import {
  BankverbindungDruck,
  Dokument as BffDokument,
  DokumentenErstellungRequestModel,
  PhDruckdaten,
  SparteDruckdaten,
  VermittlerDruck,
  VermittlerFom,
  VorschlagDruckdaten,
  VorschlagDruckType,
} from '@ps20/bff-models';
import cloneDeep from 'lodash/cloneDeep';
import { getTarifbereich } from '@ps20-frontend/frontend-models';
import { IAppState } from '../../localStore';
import {
  addCheckoutDataToSparteDruckdaten,
  mapAntraege,
  mapBankverbindung,
  mapVermittler,
  mapVersicherungsnehmer,
} from './common-druckdaten.mapper';
import { isThhHund } from './sparten-druckdaten.mapper';

export function mapVorschlag(
  state: IAppState,
  gesamtbeitragAllerSparten: string,
  spartenDruckdaten: Array<SparteDruckdaten>,
  vorschlagType?: VorschlagDruckType,
): DokumentenErstellungRequestModel<VorschlagDruckdaten> {
  const vorschlagDaten: DokumentenErstellungRequestModel<VorschlagDruckdaten> = {
    vermittler: mapVermittlerVorschlagsdruck(state),
    versicherungsnehmer: mapVersicherungsnehmer(state),
    zahlungsmethode: {
      zahlungsart: state.zahlung.zahlungsart,
      zahlweise: state.zahlung.zahlweise,
    },
    antraege: mapAntraege(spartenDruckdaten),
    dokumentDruckdaten: {
      dokument: BffDokument.VORSCHLAG,
      sparten: deleteEmptyVermieteteWohnungen(spartenDruckdaten),
      personId: state.kdv.perId,
      gesamtbeitrag: gesamtbeitragAllerSparten,
      vorschlagType,
      dokumentId: state.dokumentId,
    },
    bankverbindung: mapBankverbindungVorschlagsdruck(state),
    sammelantragsnummer: state.sammelantragsnummer,
    tarifbereich: getTarifbereich(state.versicherungsnehmer),
  };

  const clonedVorschlagDaten: DokumentenErstellungRequestModel<VorschlagDruckdaten> =
    cloneDeep(vorschlagDaten);
  clonedVorschlagDaten.dokumentDruckdaten.sparten.forEach((sparteDruckdaten, i) => {
    clonedVorschlagDaten.dokumentDruckdaten.sparten[i] = addCheckoutDataToSparteDruckdaten(
      state,
      sparteDruckdaten,
    );
  });

  clonedVorschlagDaten.dokumentDruckdaten.sparten = deleteCheckoutDataNotRelevantForVorschlagdruck(
    clonedVorschlagDaten.dokumentDruckdaten.sparten,
  );
  return clonedVorschlagDaten;
}

function mapVermittlerVorschlagsdruck(state: IAppState): VermittlerDruck {
  const mappedVermittler = mapVermittler(state);

  if (isStringEmpty(mappedVermittler.vermittlernummer)) {
    mappedVermittler.vermittlernummer = null;
  }

  excludeFOM(mappedVermittler);

  return mappedVermittler;
}

// vermittlerFom wird auf  VermittlerFom.NONE gesetzt damit keine Validierung durchgeführt wird
function excludeFOM(mappedVermittler: VermittlerDruck): void {
  mappedVermittler.fomWithBankNameDruck.vermittlerFom = VermittlerFom.NONE;
}

function mapBankverbindungVorschlagsdruck(state: IAppState): BankverbindungDruck {
  if (isStringEmpty(state.zahlung.iban)) {
    return null;
  } else {
    return mapBankverbindung(state);
  }
}

export function deleteEmptyVermieteteWohnungen(sparten: SparteDruckdaten[]): SparteDruckdaten[] {
  (sparten as PhDruckdaten[]).forEach(sparte => {
    delete sparte.vermieteteWohnungDruckList;
  });
  return sparten;
}

export function deleteCheckoutDataNotRelevantForVorschlagdruck(
  sparten: Array<SparteDruckdaten>,
): SparteDruckdaten[] {
  deleteEmptyVermieteteWohnungen(sparten);
  return deleteMeldebehoerde(sparten);
}

function deleteMeldebehoerde(sparten: SparteDruckdaten[]): SparteDruckdaten[] {
  return sparten.map(sparte => {
    if (isThhHund(sparte)) {
      return {
        ...sparte,
        meldebehoerde: null,
      } as SparteDruckdaten;
    }
    return sparte;
  });
}

function isStringEmpty(value: string): boolean {
  return value == null || value.trim().length === 0;
}
